export const loginChannelName = "wolfkrow-login";
export const logoutChannelName = "wolfkrow-logout";
